<template>
    <div class="headmesg">
        <div class="main">
            <el-badge :value="111" :max="99">
                <i class="el-icon-bell"></i>
            </el-badge>
        </div>
        <div class="mesgdown">
            <div class="mesgtop mesgbox">
                <span>消息中心</span>
                <span>接收设置</span>
            </div>
            <div class="mesgmain">
                <div class="mesgbox">
                    <span class="span-l">全部消息</span>
                    <span>(<span class="numcolor">{{num}}</span>)</span>
                </div>
                <div class="mesgbox">
                    <span class="span-l">产品消息</span>
                    <span>(<span class="numcolor">{{num}}</span>)</span>
                </div>
                <div class="mesgbox">
                    <span class="span-l">安全消息</span>
                    <span>(<span class="numcolor">{{num}}</span>)</span>
                </div>
                <div class="mesgbox">
                    <span class="span-l">服务消息</span>
                    <span>(<span class="numcolor">{{num}}</span>)</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      num: 11
    }
  }
}
</script>
<style lang="less" scoped>
.headmesg{
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    width: 70px;
    &:hover{
        background: #ececec;
        .mesgdown{
            display: block
        }
    }
    .mesgdown{
        display: none;
        position: absolute;
        width: 250%;
        top: 50px;
        background: #fff;
        font-size: 13px;
        box-shadow: #ececec  0px 0px 10px;
        .mesgbox{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 10px 15px;
        }
        .mesgtop{
            background: #ececec;
            border-bottom: 1px solid rgba(0,0,0,.1);
            span:nth-child(2){
                color: #0079fe
            }
        }
        .mesgmain{
            .mesgbox{
                .span-l:hover{
                    color: #0079fe
                }
                .numcolor{
                    color: #F04844
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/Headmessages.vue